<template>
    <div class="sdr-box contact-box" style="border: 3px solid #ffb400;">
        <h4
            style="color: #0082c8; font-weight:700;"
            v-html="importantinfosheader[getCurrentLocale]"
        ></h4>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-insurance"></i><a href="/infos-serviceonboard/#/serviceonboard"> {{ importantinfostext[getCurrentLocale] }}</a></span>
        </address>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            importantinfosheader: {
                en: 'Important infomation',
                de: 'Wichtige Hinweise',
            },
            importantinfostext: {
                en: 'for seat and special reservations',
                de: 'für Sitzplatz- und Servicereservierung',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: {

        ...mapGetters(['getCurrentLocale']),

    }, // eof computed{}
    /* <<< ****************************************************************/
};
</script>

<style scoped>
</style>